const formatParaInput = (fechaHoras: string): string => {
    const date = new Date(fechaHoras);                                                                                                      
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const formatted = `${year}-${month}-${day}T${hours}:${minutes}`;
    return formatted;
    
}
    const formatParaMostrar = (fechaHora: string) => {
        const date = new Date(fechaHora).toLocaleDateString("es-AR", {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
        return date;
    }   

export { formatParaInput, formatParaMostrar };